import { useEffect } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import Home from "components/pages/Home";
import AIToken from "components/pages/AIToken";
import ChatBot from "components/pages/EmbedPage/ChatBot";
import Exercises from "components/pages/EmbedPage/Exercises";
import Login from "components/pages/Login";
import UniversityCourses from "components/pages/UniversitySide/UniversityCourses";
import UniversityCourse from "components/pages/UniversitySide/UniversityCourse";
import { useAuth } from "AuthContext";
import StudentCourses from "components/pages/StudentSide/StudentCourses";
import StudentCourse from "components/pages/StudentSide/StudentCourse";
import UniversityStudents from "components/pages/UniversitySide/UniversityStudents";
import UniversityMajors from "components/pages/UniversitySide/UniversityMajors";
import MajorAssignment from "components/pages/UniversitySide/UniversityMajors/MajorAssignment";

import ForgetPassword from "components/pages/ForgetPassword";
import FullMask from "components/layout/FullMask";
import MessagePage from "components/general/MessagePage";
import { Button } from "antd";
import Dashboard from "components/pages/Dashboard";
import UniversityLesson from "components/pages/UniversitySide/UniversityLesson";
import StudentEnrollment from "components/pages/StudentSide/StudentEnrollment";
import { SmileOutlined } from "@ant-design/icons";
import Tutorial from "components/pages/Tutorial";
import Test from "components/pages/Test";
import StudentCalendar from "components/pages/StudentSide/StudentCalendar";
import StudentTest from "components/pages/StudentSide/StudentTest";
import UniversityTerms from "components/pages/UniversitySide/UniversityTerms";
import UniversityTests from "components/pages/UniversitySide/UniversityTests";
import UniversityTest from "components/pages/UniversitySide/UniversityTest";
import UniversityTeachers from "components/pages/UniversitySide/UniversityTeachers";
import UniversityTuition from "components/pages/UniversitySide/UniversityTuition";
import Account from "components/pages/Account";
import UserInfo from "components/pages/UserInfo";
import StudentPost from "components/pages/StudentSide/StudentPost";

function NotFound({ permission }) {
    useEffect(() => {
        document.title = `hoctot.ai - ${
            permission ? "Không có quyền truy cập" : "Trang không tồn tại"
        }`;
        // eslint-disable-next-line
    }, []);

    const navigate = useNavigate();
    return (
        <MessagePage
            status={permission ? "403" : "404"}
            title="OOPS"
            subTitle={
                permission
                    ? "Bạn không có quyền truy cập vào trang này."
                    : "Trang bạn cố gắng truy cập không tồn tại."
            }
            extra={
                <Button type="primary" onClick={() => navigate("/")}>
                    Trở về trang chủ
                </Button>
            }
        />
    );
}

export { NotFound };

function Implementing() {
    const navigate = useNavigate();
    return (
        <MessagePage
            icon={<SmileOutlined />}
            title="Chúng tôi đang phát triển tính năng này, bạn vui lòng đợi bản cập nhật trong tương lai nhé!"
            extra={
                <Button type="primary" onClick={() => navigate("/")}>
                    Trở về trang chủ
                </Button>
            }
        />
    );
}

var setHeaderG;

function Ro({ element, hasHeader = true, allowRole = 0, title="Hệ thống học tập AI" }) {
    const navigate = useNavigate();
    const location = useLocation();
    const { user, firstGettingUser } = useAuth();

    if (firstGettingUser) return <FullMask />;
    if (allowRole !== null && !user) {
        navigate(`/login?next=${location.pathname}`);
        return null;
    }
    if (allowRole !== null && user.role > allowRole) {
        document.title = "Không có quyền truy cập";
        return <NotFound permission />;
    }
    document.title = title;
    setHeaderG(hasHeader);
    return element;
}

export default function AppRoute({ setHeader }) {
    setHeaderG = setHeader;

    return (
        <Routes>
            <Route
                path=""
                element={<Ro element={<Home />} allowRole={100} />}
            />
            <Route path="/ai-token" element={<Ro element={<AIToken />} />} />
            {/* user page */}
            <Route
                path="/account"
                element={<Ro element={<Account />} allowRole={100} title="Thông tin tài khoản" />}
            />
            <Route
                path="/dashboard"
                element={<Ro element={<Dashboard />} allowRole={100} title="Dashboard" />}
            />
            {/* base */}
            <Route
                path="/login"
                element={
                    <Ro
                        hasHeader={false}
                        element={<Login />}
                        allowRole={null}
                        title="Đăng nhập"
                    />
                }
            />
            <Route
                path="/forget-password"
                element={
                    <Ro
                        hasHeader={false}
                        element={<ForgetPassword />}
                        allowRole={null}
                        title="Quên mật khẩu"
                    />
                }
            />
            <Route
                path="/tutorial/*"
                element={<Ro element={<Tutorial />} allowRole={100} title="Hướng dẫn sử dụng" />}
            />
            <Route
                path="/users/:id"
                element={
                    <Ro
                        element={<UserInfo />}
                        allowRole={100}
                        title="Thông tin tài khoản"
                    />
                }
            />
            {/* embed */}
            <Route
                path="/chatbot"
                element={
                    <Ro
                        hasHeader={false}
                        element={<ChatBot />}
                        allowRole={null}
                    />
                }
            />
            <Route
                path="/exercises"
                element={
                    <Ro
                        hasHeader={false}
                        element={<Exercises />}
                        allowRole={null}
                    />
                }
            />
            {/* student */}
            <Route
                path="/student-content"
                element={<Ro element={<Implementing />} allowRole={100} />}
            />
            <Route
                path="/student-new"
                element={<Ro element={<Implementing />} allowRole={100} />}
            />
            <Route
                path="/student-enrollment"
                element={<Ro element={<StudentEnrollment />} allowRole={100} title="Đăng ký môn học" />}
            />
            <Route
                path="/student-courses"
                element={<Ro element={<StudentCourses />} allowRole={100} title="Danh sách môn học" />}
            />
            <Route
                path="/student-courses/:id/*"
                element={<Ro element={<StudentCourse />} allowRole={100} title="Môn học" />}
            />
            {/* <Route
                path="/student-lessons/:id"
                element={<Ro element={<StudentLesson />} allowRole={100} title="Bài học" />}
            /> */}
            <Route
                path="/student-calendar"
                element={<Ro element={<StudentCalendar />} allowRole={100} title="Lịch" />}
            />
            <Route
                path="/student-test/:id"
                element={<Ro element={<StudentTest />} allowRole={100} title="Bài kiểm tra" />}
            />
            {/* university */}
            <Route
                path="/university-tuition"
                element={<Ro element={<UniversityTuition />} allowRole={1} title="Quản lý học phí" />}
            />
            <Route
                path="/university-courses"
                element={<Ro element={<UniversityCourses />} allowRole={2} title="Quản lý môn học" />}
            />
            <Route
                path="/university-courses/:id/*"
                element={<Ro element={<UniversityCourse />} allowRole={2} title="Quản lý môn học" />}
            />
            <Route
                path="/university-lessons/:id"
                element={<Ro element={<UniversityLesson />} allowRole={2} title="Quản lý bài học" />}
            />
            <Route
                path="/university-students"
                element={<Ro element={<UniversityStudents />} allowRole={1} title="Quản lý sinh viên" />}
            />
            <Route
                path="/university-teachers"
                element={<Ro element={<UniversityTeachers />} allowRole={1} title="Quản lý giảng viên" />}
            />
            <Route
                path="/university-terms"
                element={<Ro element={<UniversityTerms />} allowRole={1} title="Quản lý kỳ học" />}
            />
            <Route
                path="/university-majors"
                element={<Ro element={<UniversityMajors />} allowRole={1} title="Quản lý ngành học" />}
            />
            <Route
                path="/university-majors/:id"
                element={<Ro element={<MajorAssignment />} allowRole={1} title="Ngành học" />}
            />
            <Route
                path="/university-tests"
                element={<Ro element={<UniversityTests />} allowRole={2} title="Quản lý bài kiểm tra" />}
            />
            <Route
                path="/university-tests/:id"
                element={<Ro element={<UniversityTest />} allowRole={2} title="Quản lý bài kiểm tra" />}
            />

            <Route
                path="/student-posts/:id"
                element={<Ro element={<StudentPost />} allowRole={100} title="Hỏi đáp" />}
            />

            <Route
                path="/student-posts/"
                element={<Ro element={<StudentPost />} allowRole={100} title="Hỏi đáp" />}
            />
            {/* not found */}
            <Route
                path="*"
                element={
                    <Ro
                        element={<NotFound />}
                        hasHeader={true}
                        allowRole={null}
                        title="Không tìm thấy trang"
                    />
                }
            />
            {/* test */}
            {process.env.NODE_ENV === "development" && (
                <Route
                    path="/test"
                    element={
                        <Ro
                            element={<Test />}
                            hasHeader={true}
                            allowRole={null}
                        />
                    }
                />
            )}
        </Routes>
    );
}
